import React, { useEffect, useState } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Input from "../../controls/Input";
import { toast } from "react-toastify";
import Loading from "../../controls/Loading";
import Autocompletesearch from "../../controls/Autocompletesearch";
import { useSelector } from "react-redux";
import { handleAddAttendance, handleEditAttendance } from "../../../api/AttendanceApi";
import { IoTimerOutline } from "react-icons/io5";
import Select from "../../controls/Select";
import { getLocationWithFallback } from "../../../api/geolocationService";
import { fetchAllEmployees } from "../../../api/staffApi";

const CaptureAttendance = ({
  setDrawer,
  onSave,
  editData,
}) => {
  const store = useSelector((store) => store.store.store);
  console.log("selected store", store);
  console.log("EditData",editData);
  const [employee, setEmployee] = useState(editData?.Employee?.label || "");
  const [employeeId, setEmployeeId] = useState(editData?.Employee?.value || "");
  const [date, setDate] = useState(editData?.Date || new Date().toISOString().split('T')[0]);
  const [status, setStatus] = useState(editData?.AttendanceType || "");
  const [inTime, setInTime] = useState(editData?.InTime || { HH: "", MM: "", AMPM: "AM" });
  const [outTime, setOutTime] = useState(editData?.OutTime || { HH: "", MM: "", AMPM: "" });
  const [remark, setRemark] = useState(editData?.Remarks || "");
  const [loading, setLoading] = useState("");



  const [employees, setEmployees] = useState([]);


  const [employeeError, setEmployeeError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [inTimeError, setInTimeError] = useState("");
  const [outTimeError, setOutTimeError] = useState("");
  const [dateError, setDateError] = useState("");




  const fetchEmployeeData = async () => {

    try {
      const response = await fetchAllEmployees(
        store.key
      );

      if (response?.code === "0") {
        setEmployees(response.activeEmployees);
        setLoading(false);
        console.log("employee", response);
      } else {
        const errorMessage = response?.message || "Failed to fetch employee";
        console.error("Failed to fetch employee:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Runtime error while fetching employee:", error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred"
      );
    } 
  };

  // const captureLocation = async () => {
  //   try {
  //     toast.info("capturing location...");
  //     setLocationError("Capturing location...");
  //     const loc = await getLocationWithFallback();
  //     if (loc) {
  //       setLocation(loc);
  //       console.log("location get", loc);
  //       setLocationError("");
  //     } else {
  //       toast.error("colud not determine location");
  //       setLocationError("Could not determine location");
  //     }
  //   } catch (error) {
  //     console.error("Location error:", error);
  //     toast.error("Location access denied or unavailable");
  //     setLocationError("Location access denied or unavailable");
  //   }
  // };




  const handleSaveClick = async () => {

    let employeeError = "";
    let statusError = "";
    let inTimeError = "";
    let dateError = "";

    if (employee == "" && employeeId == "") {
      employeeError = "please select employee";
    }

    if (status == "" || !status) {
      statusError = "please select status";
    }

    if (!date) {
      dateError = "Please select date";
    }

    if (status.trim() !== '' && status.trim() !== "Leave" && status.trim() !== "Week-Off") {
      if (inTime.HH.trim() === '' || inTime.MM === '' || inTime.AMPM === '') {
        inTimeError = "Please specify time"
      }
    }

    // if (inTime.HH == "") {
    //   inTimeError = "please enter time";
    // }
    // if (inTime.HH !== "") {
    //   if (inTime.AMPM == "") {
    //     inTimeError = "please select Am Pm";
    //   }
    // }

    if (employeeError !== "" || statusError !== "" || inTimeError !== "") {
      setEmployeeError(employeeError);
      setStatusError(statusError);
      setInTimeError(inTimeError);
      setDateError(dateError);
      return;
    }
    if (!location && status === "Present") {
      toast.error("Location is required for present attendance");
      setLocationError("Location is required for present attendance");
      return;
    }

    const payload = {
      Employee: {
        label: employee,
        value: employeeId
      },
      Date: date,
      AttendanceType: status,
      InTime: inTime,
      OutTime: outTime,
      Remarks: remark,
      StoreID: store.key,
      ...(editData?.key && { key: editData.key })
    };



    try {
      setLoading(true);
      let response = null;

      if (editData?.key) {
        response = await handleEditAttendance(payload);
      } else {
        response = await handleAddAttendance(payload);
      }

      if (response.code === "0") {
        toast.success(editData?.key ? "Attendance updated successfully" : "Attendance added successfully");
        setDrawer(false);
        setLoading(false);
          onSave(response);
      } else {
        console.error("Failed to save attendance:", response);
        // Fix: Properly access the error message from response.data.error
        toast.error(response.data?.error || "Failed to save attendance");
        setLoading(false);
      }
    }
    catch (error) {
      console.error("Failed to save attendance:", error);
      // Fix: Show the actual error message if available
      toast.error(error.response?.data?.error || error.message || error?.error || "Failed to save attendance");
      setLoading(false);
    }

  };



  useEffect(() => {
    fetchEmployeeData();
  }, [store]);

  const setCurrentTime = (setTimeFunction) => {  // Changed parameter name to be more clear
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12;

    setTimeFunction({
      HH: hours.toString().padStart(2, '0'),
      MM: minutes.toString().padStart(2, '0'),
      AMPM: ampm
    });

    // Clear errors based on which setter was called
    if (setTimeFunction === setInTime) {
      setInTimeError("");
    }
    if (setTimeFunction === setOutTime) {
      setOutTimeError("");
    }
  };

  return (
    <CustomDrawer
      setDrawer={setDrawer}
      title={editData?.key ? "Edit Attendance" : "Add Attendance"}
      drawerType={"medium"}
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Save", Type: "primary", Icon: "save" },
      ]}
      onButtonClick={(label) => {
        if (label === "Save") handleSaveClick();
        else if (label === "Cancel") setDrawer(false);
      }}
    >
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col gap-4">
          <Autocompletesearch
            value={employee}
            defaultDataCount={20}
            label="Employee"
            data={employees}
            filterKey={["EmployeeFirstName", "EmployeeLastName", "EmployeeCode", "PhoneNo", "EmailID"]}
            onChange={(value) => {
              setEmployee("");
              setEmployeeId("");
            }}
            onSelect={(selectedItem) => {
              setEmployee(`${selectedItem.EmployeeFirstName} ${selectedItem.EmployeeLastName}`);
              setEmployeeId(selectedItem.key);
              setEmployeeError("");
            }}
            placeholder="Select employee"
            renderSuggestion={(item) => (
              <div>
                <div className="font-semibold">{item.EmployeeCode} {item.EmployeeFirstName} {item.EmployeeLastName}</div>
                <div className="text-sm">
                  {item.PhoneNo && <div>{item.PhoneNo}</div>}
                  {item.EmailID && <div>{item.EmailID}</div>}
                </div>

              </div>
            )}
            errorMessage={employeeError}
          />

          <Input
            label="Date"
            value={date}
            type={"date"}
            onChange={(e) => {
              setDate(e.target.value);
              setDateError("");
            }}
            errorMessage={dateError}
          />

          <Select
            label="Status"
            placeholder="Select"
            options={[{ label: "Present", value: "Present" }, { label: "Half Day", value: "Half Day" },
            { label: "Leave", value: "Leave" }, { label: "Week-Off", value: "Week-Off" },]}
            value={status}
            onChange={(e) => { setStatus(e.target.value), setStatusError("") }}
            errorMessage={statusError}
          />
          {(status != "Leave" && status != "Week-Off") && <>
          <div>
            <label>In time</label>
            <div className="flex items-center gap-2">
              <div className="w-[80px]">
                <Input
                  type="number"
                  min="1"
                  max="12"
                  value={inTime.HH}
                  onChange={(e) => {
                    setInTime({ ...inTime, HH: e.target.value });
                    setInTimeError("");
                  }}
                />
              </div>
              <div className="w-[80px]">
                <Input
                  type="number"
                  min="0"
                  max="59"
                  value={inTime.MM}
                  onChange={(e) => {
                    setInTime({ ...inTime, MM: e.target.value });
                    setInTimeError("");
                  }}
                />
              </div>
              <div className="w-[70px]">
                <Select
                  options={[
                    { value: "AM", label: "AM" },
                    { value: "PM", label: "PM" }
                  ]}
                  value={inTime.AMPM}
                  onChange={(e) => {
                    setInTime({ ...inTime, AMPM: e.target.value });
                    setInTimeError("");
                  }}
                />
              </div>
              <span
                onClick={() => { setCurrentTime(setInTime) }}  // Pass setInTime directly
                className="mt-2 flex items-center cursor-pointer text-xl"
              >
                <IoTimerOutline />
              </span>
            </div>
            {inTimeError && (
              <div className="text-red-700 text-sm">{inTimeError}</div>
            )}
          </div>

          <div>
            <label>Out time</label>
            <div className="flex items-center gap-2">
              <div className="w-[80px]">
                <Input
                  type="number"
                  min="1"
                  max="12"
                  value={outTime.HH}
                  onChange={(e) => {
                    setOutTime({ ...outTime, HH: e.target.value });
                    setOutTimeError("");
                  }}
                />
              </div>
              <div className="w-[80px]">
                <Input
                  type="number"
                  min="0"
                  max="59"
                  value={outTime.MM}
                  onChange={(e) => {
                    setOutTime({ ...outTime, MM: e.target.value });
                    setOutTimeError("");
                  }}
                />
              </div>
              <div className="w-[70px]">
                <Select
                  options={[
                    { value: "AM", label: "AM" },
                    { value: "PM", label: "PM" }
                  ]}
                  value={outTime.AMPM}
                  onChange={(e) => {
                    setOutTime({ ...outTime, AMPM: e.target.value });
                    setOutTimeError("");
                  }}
                />
              </div>
              <span
                onClick={() => { setCurrentTime(setOutTime) }}  // Pass setOutTime directly
                className="mt-2 flex items-center cursor-pointer text-xl"
              >
                <IoTimerOutline />
              </span>
            </div>

            {outTimeError && (
              <div className="text-red-700 text-sm">{outTimeError}</div>
            )}
          </div>
         </> }
          <Input
            label="Remark"
            value={remark}
            onChange={(e) => {
              setRemark(e.target.value);
            }}
          />

        </div>

      )}
    </CustomDrawer>
  );
};

export default CaptureAttendance;